<template>
  <div>
    <div class="common-new-title mode2">
      <span>{{ title }}</span>
      <div class="title-bottom" v-if="btnOptPermission">
        <slot name="add-btn">
          <el-button
            size="medium"
            type="primary"
            class="jm-button-search"
            @click="visitHandle({ crmid: userId }, 'visit', '快捷回访', 'increase', type)"
          >新增</el-button>
        </slot>
        <el-button
          v-show="!noAppointment && type !== 'listenOperate'"
          size="medium"
          type="primary"
          @click="visitHandle({ crmid: userId }, 'appointment', '预约回访')"
        >预约回访</el-button>
        <el-button @click="doRefresh">
          <i class="el-icon-refresh"></i>
        </el-button>
      </div>
      <div class="title-bottom">
        <span v-if="type === 'fibOperate'">
          <el-checkbox
            :true-label="1"
            :false-label="0"
            :disabled="!btnOptPermission"
            v-model="otherPushed">用户运营双推</el-checkbox>
        </span>
      </div>
    </div>
    <!--学生回访 列表 start-->
    <tableList :refresh.sync="refresh" :url="dataUrl">
      <el-table-column slot="vist_str" label="记录" width="400">
        <template slot-scope="scope">{{ scope.row.vist_str }}</template>
      </el-table-column>
      <el-table-column slot="feedback" label="老师反馈" width="400">
        <template slot-scope="scope">
          <el-tooltip popper-class="table-tooltip-area" effect="dark" :content="scope.row.feedback" placement="top">
            <span style="white-space: nowrap;display: block;">{{ scope.row.feedback }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        slot="url"
        label="截图"
        min-width="80">
        <template slot-scope="scope">
          <img style="max-height: 40px; cursor: pointer" @click="viewBigImg(scope.row.url)" :src="scope.row.url" alt="" v-if="scope.row.path">
        </template>
      </el-table-column>
      <el-table-column v-if="tableOptPermission" slot="lastColumn" label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button
            size="medium"
            type="primary"
            :disabled="userInfo.userid !== scope.row.adminuid && type !== 'listenOperate'"
            @click="visitHandle({ id: scope.row.id, ...scope.row }, 'visit', '快捷回访', '', type)"
          >编辑</el-button>
          <el-button
            v-show="deleteUrl"
            size="medium"
            type="danger"
            :disabled="userInfo.userid !== scope.row.adminuid"
            @click="deleteVisit(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>
    </tableList>
    <!--快捷回访 预约回访 父层组件 S-->
    <visit-form-dialog
      :visible.sync="visitVisible"
      :title="visitDialogTitle"
      :type="visitType"
      :data-set="visitData"
      :operate-visit="userOperateVisit"
      :increase-type="increaseType"
      @finished="finishedSave"
      v-bind="$attrs"
      :crm_level="crm_level"
      :crm_sayer="crm_sayer"
    />
    <!--快捷回访 预约回访 父层组件 E-->

    <!--预约试听 S-->

    <el-dialog title="预约试听" :visible.sync="listenVisible">
      <el-form :model="listenForm">
        <el-form-item label="预约时间：" label-width="100">
          <el-date-picker
            class="jm-input220"
            v-model="listenForm.booking_time"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <el-form-item label="试听老师：" label-width="100">
          <el-select v-model="listenForm.booking_teacher_id" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="(group, k) in jsTeachers"
              :key="k"
              :label="k">
              <el-option
                v-for="item in group"
                :key="item.userid"
                :label="item.truename"
                :value="item.userid"/>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="学生：" v-if="listenForm.id">
          <span>【姓名：{{ listenForm.user.username }}，电话：{{ listenForm.user.tel }}，微信：{{ listenForm.user.wechat }}】</span>
        </el-form-item>
        <el-form-item label="预约内容：">
          <el-input type="textarea" v-model="listenForm.memo"></el-input>
        </el-form-item>
        <el-form-item label="教师反馈：">
          <el-input type="textarea" v-model="listenForm.feedback" :rows="8"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="listenVisible = false">取 消</el-button>
        <el-button type="primary" @click="listenSave">确 定</el-button>
      </div>
    </el-dialog>
    <!--预约试听 E-->
    <!--大图查看-->
    <view-large-image :visible.sync="viewImageLock" :img-url="visitImage"></view-large-image>
  </div>
</template>
<script>
import tableList from '@/components/data/tableList';
import visitFormDialog from '@/components/tool/visitFormDialog';
import { mapGetters } from 'vuex';
import ElFormItem from 'element-ui/packages/form/src/form-item';
import studentMixin from '@/pages/student/student.js';
import viewLargeImage from '@/components/pop/viewLargeImage';

export default {
  name: 'CustomerVisit',
  props: {
    title: {
      type: String,
      default: ''
    },
    userId: {
      type: [Number, String],
      required: true
    },
    dataUrl: {
      type: String,
      required: true
    },
    deleteUrl: {
      type: String,
      default: '',
    },
    // 按钮操作权限
    btnOptPermission: {
      type: Boolean,
      default: true,
    },
    // 数据表操权限
    tableOptPermission: {
      type: Boolean,
      default: true,
    },
    // 主要用来标识是否是运营回访
    type: {
      type: String,
      default: ''
    },

    noAppointment: {
      type: Boolean,
      default: false,
    },
    crm_level: {
      type: [Number, String],
    },
    crm_sayer: {
      type: [Number, String],
      default: 0
    },
    jw_teacher: {
      type: [Number, String],
      default: 0
    },
    otherPushed: {
      type: [Number, String],
      default: 0
    },
    overrideEditItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      refresh: false,
      visitData: {},
      visitVisible: false, // 是否显示回访表单模态窗口
      visitType: '',
      visitDialogTitle: '',
      increaseType: '',
      userOperateVisit: '', // 是否是用户运营回访
      listenVisible: false,
      listenForm: {
        booking_time: '',
        booking_teacher: '',
        booking_teacher_id: '',
        memo: '',
        feedback: '',
        user: {},
        teacher: {},
      },
      jsTeachers: [],
      viewImageLock: false,
      visitImage: '',
    };
  },
  mixins: [studentMixin],
  components: {
    ElFormItem,
    tableList,
    visitFormDialog,
    viewLargeImage
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    // console.log(this.crm_sayer);
    this.getDatasource().then(() => {
      this.jsTeachers = this.ds.js_teacher;
    });
  },
  methods: {
    doRefresh() {
      this.refresh = true;
    },
    finishedSave() {
      this.doRefresh();
      this.$emit('afterSave', true);
    },
    listenSave() {
      this.listenForm.userid = this.$route.params.id;
      if (!this.listenForm.adminuid) {
        this.listenForm.adminuid = this.userInfo.userid;
      }
      // console.log(111111111,this.listenForm.adminuid);
      // return;
      this.listenForm.booking_teacher = this.listenForm.booking_teacher_id;
      this.$http._post({
        url: '/training/booking/save',
        data: this.listenForm,
      }).then(() => {
        this.$message.success('操作成功');
        this.listenVisible = false;
        this.doRefresh();
      });
    },

    viewBigImg(url) {
      if (url) {
        this.visitImage = url;
        this.viewImageLock = true;
      } else {
        this.$message.error('图片路径错误');
      }
    },
    /**
     * 预约 and 预约回访
     */
    visitHandle(data, type, title, increase, userOperateVisit = '') {
      if (this.type === 'listenOperate') {
        if (!this.jw_teacher) {
          this.$message.error('请先设置资源的教务老师，再新增预约课');
          return;
        }
        this.listenForm = data;
        this.listenVisible = true;
        return;
      }
      if (!this.overrideEditItem) {
        this.visitData = data;
        this.visitVisible = true;
        this.visitType = type;
        this.visitDialogTitle = title;
        this.increaseType = increase;
        this.userOperateVisit = userOperateVisit;
      }
      this.$emit('editLog', data);
    },
    async doDelete(id) {
      try {
        await this.$http._delete({
          url: `${this.deleteUrl}/${id}`,
        });
        this.$message.success('删除成功');
        this.doRefresh();
      } catch (e) {
        this.$message.error('删除失败');
      }
    },
    /**
     * 学生回访 删除
     */
    async deleteVisit(id) {
      try {
        await this.$confirm('此操作将删除此条信息，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await this.doDelete(id);
      } catch (e) {
        this.$message.info('已取消删除');
      }
    }
  },
  watch: {
    otherPushed (val) {
      this.$http._post({
        url: '/index/student/simpleSave',
        data: {
          id: this.userId,
          other_pushed: val ? 1 : 0
        },
      }).then(({ data }) => {
        if (data === 1) {
          this.$message.success(val ? '成功双推' : '取消双推');
        }
      });
    }
  }
};
</script>
<style lang="less">
.basic-title {
  height: 35px;
  line-height: 35px;
  margin: 10px 8px 15px;
  position: relative;
  cursor: default;
  border-bottom: 1px solid #b8c4ce;
}
.common-new-title {
  margin-top: 10px;
  & > span {
    display: inline-block;
  }
  .title-bottom {
    float: right;
  }
}
.form-wrapper {
  padding: 20px 20px 1px 20px;
  position: relative;
}
.form-tip {
  position: absolute;
  z-index: 10000000;
  right: 34px;
  top: 55px;
  width: 300px;
}
</style>
